import React from 'react';
import {store} from '../../index';
import App from './Hero';


export default function(props:any){
    return <App info={props.info} loading={props.loading} fetchStats={props.fetchStats} background_url={store.getState().dashboard.background_url}></App>;
}